<template>
    <!-- screen loader -->
    <div
        v-show="store.isShowMainLoader"
        class="screen_loader fixed inset-0 bg-[#fafafa] dark:bg-[#060818] z-[60] grid place-content-center animate__animated"
    >
        <svg width="64" height="64" viewBox="0 0 135 135" xmlns="http://www.w3.org/2000/svg" fill="#0e52ad">
            <path
                d="M67.447 58c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm9.448 9.447c0 5.523 4.477 10 10 10 5.522 0 10-4.477 10-10s-4.478-10-10-10c-5.523 0-10 4.477-10 10zm-9.448 9.448c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zM58 67.447c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10z"
            >
                <animateTransform attributeName="transform" type="rotate" from="0 67 67" to="-360 67 67" dur="2.5s"
                                  repeatCount="indefinite" />
            </path>
            <path
                d="M28.19 40.31c6.627 0 12-5.374 12-12 0-6.628-5.373-12-12-12-6.628 0-12 5.372-12 12 0 6.626 5.372 12 12 12zm30.72-19.825c4.686 4.687 12.284 4.687 16.97 0 4.686-4.686 4.686-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97zm35.74 7.705c0 6.627 5.37 12 12 12 6.626 0 12-5.373 12-12 0-6.628-5.374-12-12-12-6.63 0-12 5.372-12 12zm19.822 30.72c-4.686 4.686-4.686 12.284 0 16.97 4.687 4.686 12.285 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.97-4.685-4.687-12.283-4.687-16.97 0zm-7.704 35.74c-6.627 0-12 5.37-12 12 0 6.626 5.373 12 12 12s12-5.374 12-12c0-6.63-5.373-12-12-12zm-30.72 19.822c-4.686-4.686-12.284-4.686-16.97 0-4.686 4.687-4.686 12.285 0 16.97 4.686 4.687 12.284 4.687 16.97 0 4.687-4.685 4.687-12.283 0-16.97zm-35.74-7.704c0-6.627-5.372-12-12-12-6.626 0-12 5.373-12 12s5.374 12 12 12c6.628 0 12-5.373 12-12zm-19.823-30.72c4.687-4.686 4.687-12.284 0-16.97-4.686-4.686-12.284-4.686-16.97 0-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0z"
            >
                <animateTransform attributeName="transform" type="rotate" from="0 67 67" to="360 67 67" dur="8s"
                                  repeatCount="indefinite" />
            </path>
        </svg>
    </div>
    <div
        class="main-section antialiased relative font-nunito text-sm font-normal"
        :class="[store.sidebar ? 'toggle-sidebar' : '', store.menu, store.layout, store.rtlClass]"
    >
        <component v-if="store.mainLayout" v-bind:is="mainLayout"></component>
    </div>

    <a href="https://wa.me/966580282807" class="whatsapp-float" target="_blank">
        <i class="pi pi-whatsapp" style="font-size: 1.5rem"/>
    </a>
</template>

<script lang="ts" setup>
    import { computed, onMounted } from 'vue';

    import appLayout from '@/layouts/app-layout.vue';
    import authLayout from '@/layouts/auth-layout.vue';

    import { useAppStore } from '@/stores/index';
    import { useMeta } from '@/composables/use-meta';
    import { setToastInstance } from '@/axios';
    import { useToast } from 'primevue/usetoast';
    import { useAuthStore } from '@/stores/auth';

    const store = useAppStore();
    const authStore = useAuthStore();

    // meta
    useMeta({ title: '' });

    const mainLayout = computed(() => {
        return store.mainLayout === 'auth' ? authLayout : appLayout;
    });

    onMounted(() => {
        setToastInstance(useToast());
    });

    // add user email to the Jira Widget
    // setTimeout(() => {
    //     const observer = new MutationObserver((mutationList, observer) => {
    //         store.helpButton = document.getElementById('jsd-widget').contentWindow.document.getElementById('help-button');
    //
    //         if (store.helpButton) {
    //             store.helpButton.addEventListener('click', () => {
    //                 setTimeout(() => {
    //                     const emailInput = document.getElementById('jsd-widget').contentWindow.document.getElementById('email');
    //
    //                     if (emailInput && emailInput.value?.length === 0 && authStore.user?.email) {
    //                         emailInput.value = authStore.user.email;
    //                     }
    //                 });
    //             });
    //         }
    //     });
    //
    //     const jiraWidget = document.getElementById('jsd-widget').contentWindow.document.getElementById('react-root');
    //
    //     if (jiraWidget) {
    //         observer.observe(jiraWidget, { attributes: false, childList: true, subtree: true });
    //     } else {
    //         console.error('Jira Widget is not found');
    //     }
    //
    //     return () => observer.disconnect();
    // });
</script>
